import React, { useState } from 'react';
import './FaqAccordion.css';

const FAQS = [
    {
        q: 'Is Gradies safe to buy cards from?',
        a: 'Yes. Every card on Gradies is PSA graded and ships from inside the US. You can click any graded card at checkout to verify it directly on PSA’s website before you buy.',
    },
    {
        q: 'Are the cards authentic?',
        a: 'Yes. Every listing is a PSA graded card. PSA authenticates each card before they grade it, and we show you the actual front and back photos of the exact cert you’re buying.',
    },
    {
        q: 'How does pricing work?',
        a: 'Prices are set by the sellers on our site. We show PriceCharting estimates at checkout so you can see what the same card sells for at PSA 10, 9, 8 and 7.',
    },
    {
        q: 'How do I buy a card on Gradies?',
        a: 'Search or browse, open the listing, and check out securely with PayPal payments.',
    },
    {
        q: 'What happens after I order?',
        a: 'The seller confirms your order and ships the graded card with tracking.',
    },
    {
        q: 'Can I sell my cards on Gradies?',
        a: 'Not yet. For now, sellers on gradies are trusted partnered card stores only.',
    },
];

// Accordion: question left, light-pink circle with +/− right, hairline rows.
const FaqAccordion = () => {
    const [openIdx, setOpenIdx] = useState(null);

    return (
        <section className="gh-faq">
            <h2 className="gh-faq-title">Frequently Asked Questions</h2>
            <div className="gh-faq-list">
                {FAQS.map((f, i) => {
                    const open = openIdx === i;
                    return (
                        <div key={f.q} className="gh-faq-item">
                            <button
                                type="button"
                                className="gh-faq-q"
                                aria-expanded={open}
                                onClick={() => setOpenIdx(open ? null : i)}
                            >
                                <span>{f.q}</span>
                                <span className={`gh-faq-toggle ${open ? 'open' : ''}`} aria-hidden="true">+</span>
                            </button>
                            {open && <p className="gh-faq-a">{f.a}</p>}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default FaqAccordion;
